/* eslint-disable */
import gql from "graphql-tag";
import { accountErrorFragment } from "@saleor/fragments/errors";
import makeMutation from "@saleor/hooks/makeMutation";
import { UpdatePopup, UpdatePopupVariables } from "./types/UpdatePopup";
import {
  LoginpopupAddVoucher,
  LoginpopupAddVoucherVariables
} from "./types/LoginpopupAddVoucher";
import {
  LoginpopupRemoveVoucher,
  LoginpopupRemoveVoucherVariables
} from "./types/LoginpopupRemoveVoucher";

import { loginPopupFragment } from "@saleor/fragments/popup";

import { LoginPopupCreateDefault } from "@saleor/popup/types/loginPopupCreateDefault";

const updatePopup = gql`
  ${accountErrorFragment}
  ${loginPopupFragment}
  mutation UpdatePopup($id: ID!, $input: LoginPopupCreateInput!) {
    loginpopupUpdate(id: $id, input: $input) {
      loginPopup {
        ...LoginPopupFragment
      }
      errors: accountErrors {
        ...AccountErrorFragment
      }
    }
  }
`;
export const useUpdatePopupMutation = makeMutation<
  UpdatePopup,
  UpdatePopupVariables
>(updatePopup);

const loginpopupRemoveVoucher = gql`
  ${accountErrorFragment}
  ${loginPopupFragment}
  mutation LoginpopupRemoveVoucher($loginPopup: ID!, $voucherCode: String) {
    loginpopupRemoveVoucher(
      loginPopup: $loginPopup
      voucherCode: $voucherCode
    ) {
      loginPopup {
        ...LoginPopupFragment
      }
      errors: accountErrors {
        ...AccountErrorFragment
      }
    }
  }
`;

export const usePopupRemoveVoucherMutation = makeMutation<
  LoginpopupRemoveVoucher,
  LoginpopupRemoveVoucherVariables
>(loginpopupRemoveVoucher);

const loginpopupAddVoucher = gql`
  ${accountErrorFragment}
  ${loginPopupFragment}
  mutation LoginpopupAddVoucher($loginPopup: ID!, $voucher: [ID]!) {
    loginpopupAddVoucher(loginPopup: $loginPopup, voucher: $voucher) {
      loginPopup {
        ...LoginPopupFragment
      }
      errors: accountErrors {
        ...AccountErrorFragment
      }
    }
  }
`;

export const usePopupAddVoucherMutation = makeMutation<
  LoginpopupAddVoucher,
  LoginpopupAddVoucherVariables
>(loginpopupAddVoucher);

const loginPopupCreateDefault = gql`
  ${loginPopupFragment}
  mutation LoginPopupCreateDefault {
    loginpopupCreateDefault {
      popup {
        ...LoginPopupFragment
      }
      errors {
        field
        message
      }
    }
  }
`;

export const useLoginPopupCreateDefaultMutation = makeMutation<
  LoginPopupCreateDefault,
  null
>(loginPopupCreateDefault);
